declare var CONFIG: any;

const {
  GMAP_KEY = '',
  GOOGLE_RECAPTCHA_PUBLIC_KEY = '',
  SOAP_ACTION_PREFIX = '',
  SOAP_API_URL = '',
  GOOGLE_API_ISSUER_ID = '',
} = CONFIG;

const env = {
  GMAP_KEY,
  GOOGLE_RECAPTCHA_PUBLIC_KEY,
  SOAP_ACTION_PREFIX,
  SOAP_API_URL,
  GOOGLE_API_ISSUER_ID,
};

export {env};
